<template>
    <div>
    </div>
</template>
    
<script>
import router from '@/router';

export default {
    name: "SignOut",
    methods:{
        deleteAllCookies() {
            const cookies = document.cookie.split(";");
          //  console.log('cookies --- ', cookies);
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i];
                const eqPos = cookie.indexOf("=");
                const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();

                // Set the cookie to expire in the past for all paths
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
                // Try to delete for each path segment (for sub-path cookies)
                let path = location.pathname;
                let pathParts = path.split('/');
                while (pathParts.length > 0) {
                    pathParts.pop();
                    let currentPath = pathParts.join('/') || '/';
                    document.cookie = name + `=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${currentPath}`;
                }
            }
        },
        redirectToLogout() {
         //   console.log('Redirecting to logout URL');
            window.location.href = process.env.VUE_APP_B2C_LOGOUT_URL;
           // window.location.reload();
        }
    },
    mounted() {
        try {
            const user = JSON.parse(localStorage.getItem("user"));
            if (user) {
                localStorage.removeItem("user");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("changePasswordReload");
                localStorage.clear();
               // console.log('before deleting cookies');
                this.deleteAllCookies();
               // console.log('after deleting cookies');

                setTimeout(() => {
                    this.redirectToLogout();
                }, 0); // 500 milliseconds delay
               // alert("Logging out user");
              // window.location.reload();
            } else {
                console.log("logout page else called : ", user);
            }
        } catch (e) {
            console.log("logout page catch called : ", e);
        }
    }
}
</script>
